import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

export const CreditBankHealthSchema = z.enum(['Ok', 'Unauthorized'])

export type CreditBankHealth = ZodInfer<typeof CreditBankHealthSchema>
